import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["searchString", "createDateFilter", "lastActivityFilter"];
import { registerMutation, useMutation } from 'data-fetching-client';
import { useCallback } from 'react';
import { generateDateFilter } from '../constants/filters';
import { api } from '../utils/api';
import { TICKET_EXPORT_CSV_PATH } from '../../api/paths';
const exportCsv = async _ref => {
  var _res$headers$get;
  let {
      searchString,
      createDateFilter,
      lastActivityFilter
    } = _ref,
    variables = _objectWithoutPropertiesLoose(_ref, _excluded);
  const res = await api(TICKET_EXPORT_CSV_PATH, {
    method: 'POST',
    body: JSON.stringify(Object.assign({
      searchString: searchString === '' ? undefined : searchString,
      dateFilters: [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(Boolean)
    }, variables)),
    headers: {
      'X-HS-User-Request': '1',
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) {
    throw new Error(`Export CSV error: ${res.status} - ${res.statusText}`);
  }
  const txt = await res.text();
  const filenameRegex = /filename="([^"]+)"/;
  const filenameMatch = (_res$headers$get = res.headers.get('Content-Disposition')) === null || _res$headers$get === void 0 ? void 0 : _res$headers$get.match(filenameRegex);
  const name = filenameMatch ? filenameMatch[1] : null;
  if (!name) {
    throw new Error('Export CSV error: No filename found');
  }
  const blob = new Blob([txt], {
    type: 'text/csv'
  });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl.toString();
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
  /* TODO Error Message or Success Message with Toast (not native in HubSpot so need Joe's advice) */
};
const EXPORT_CSV_MUTATION_FIELD_NAME = 'exportCsv';
const EXPORT_CSV_MUTATION = registerMutation({
  fieldName: EXPORT_CSV_MUTATION_FIELD_NAME,
  fetcher: exportCsv,
  args: ['ticketView', 'statusFilter', 'searchString', 'sort', 'createDateFilter', 'lastActivityFilter']
});
export const useCsvExport = variables => {
  const [mutate, {
    loading,
    error
  }] = useMutation(EXPORT_CSV_MUTATION, {});
  const doExport = useCallback(() => {
    void mutate({
      variables
    });
  }, [mutate, variables]);
  return {
    doExport,
    loading,
    error
  };
};